export default {
    name: "user-profile-1",
    path: "user-profile/",
    component: () => import(/* webpackChunkName: "app-components-entry" */ '@/components/UserProfile/user-profile.vue')
}